<template>
  <v-container
    id="openEnrollmentTab"
    class="pa-0"
  >
    <div
      v-if="editedItem.isRenewal"
      class="text-center display-1 font-weight-light mb-6 font-weight-bold green--text"
    >
      <v-icon
        color="green"
        large
      >
        mdi-refresh
      </v-icon>
      Renewal
    </div>
    <v-row>
      <v-col
        cols="6"
      >
        <base-resource-select
          label="Broker - Group"
          item-text="brokerGroupName"
          item-value="id"
          bind-text="brokerGroupName"
          bind-value="brokerGroupId"
          sort-by="brokerGroupName"
          :bind-item.sync="item"
          :error-messages="formErrors.BrokerGroupId"
          :resource="brokerGroupResource"
          :disabled="disableBrokerGroup || disabled"
          @change="onBrokerGroupChange"
        />
      </v-col>
      <v-col cols="6">
        <v-btn
          color="info"
          class="px-1 ml-1"
          fab
          x-small
          @click="toggleGroupSummary"
        >
          <v-icon>mdi-information-variant</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      v-if="groupSummaryVisible"
    >
      <v-col
        cols="12"
      >
        <v-divider
          class="mx-4"
          inset
        />
        <group-summary
          :key="groupId"
          :details="editedItem"
          :group-id="groupId"
        />
        <v-divider
          class="mx-4"
          inset
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="item.brokerGroupYear"
          :error-messages="formErrors.BrokerGroupYear"
          :disabled="disabled"
          label="Year"
          type="number"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="item.locked"
          :error-messages="formErrors.Locked"
          :disabled="disabled"
          label="Locked"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-resource-select
          label="Upload Assigned"
          item-text="userName"
          item-value="id"
          bind-text="userName"
          bind-value="uploadAssigned"
          sort-by="userName"
          :bind-item="item"
          :error-messages="formErrors.UploadAssigned"
          :fetch-method="getUploadAssigned"
          :disabled="disabled"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="item.sicCode"
          :error-messages="formErrors.SICCode"
          :disabled="disabled"
          label="SIC Code"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-row>
          <v-col
            v-if="item.platform"
            cols="12"
          >
            <base-display-value
              v-model="item.platform"
              label="Platform"
            />
          </v-col>
          <v-col
            v-if="item.platform"
            cols="12"
          >
            <v-icon>
              mdi-earth
            </v-icon>
            <a
              :href="item.siteUrl"
              target="_blank"
            >
              {{ item.siteUrl }}
            </a>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-resource-select
          label="Benefit Admin Site"
          item-text="benefitAdminSite"
          item-value="id"
          bind-text="benefitAdminSite"
          bind-value="benefitAdminSiteId"
          :bind-item="item"
          :error-messages="formErrors.BenefitAdminSiteId"
          :resource="benefitAdminSiteResource"
          :disabled="disabled"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-date-picker
          :date-value.sync="item.planYearStartDate"
          :error-messages="formErrors.PlanYearStartDate"
          :disabled="disabled"
          label="Plan Start"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-date-picker
          :date-value.sync="item.planYearEndDate"
          :error-messages="formErrors.PlanYearEndDate"
          :disabled="disabled"
          label="Plan End"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="item.selfService"
          :error-messages="formErrors.SelfService"
          :disabled="disabled"
          label="Self Service"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="item.multiYear"
          :error-messages="formErrors.MultiYear"
          :disabled="disabled"
          label="Multi Year"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-date-picker
          :date-value.sync="item.oeStartDate"
          :error-messages="formErrors.OEStartDate"
          :disabled="disabled"
          label="OE Start"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-date-picker
          :date-value.sync="item.oeEndDate"
          :error-messages="formErrors.OEEndDate"
          :disabled="disabled"
          label="OE End"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-date-picker
          :date-value.sync="item.selerixCloseDate"
          :error-messages="formErrors.SelerixCloseDate"
          :disabled="disabled"
          label="Benefit Admin Close"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-date-picker
          :date-value.sync="item.oeFileSendDate"
          :error-messages="formErrors.OEFileSendDate"
          :disabled="disabled"
          label="OE File Send"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-date-picker
          :date-value.sync="item.payrollDeadlineToBroker"
          :error-messages="formErrors.PayrollDeadlineToBroker"
          :disabled="disabled"
          label="Payroll Deadline Broker"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <base-date-picker
          :date-value.sync="item.payrollDeadlineToGroup"
          :error-messages="formErrors.PayrollDeadlineToGroup"
          :disabled="disabled"
          label="Payroll Deadline Group"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="item.uploadOrPayrollFile"
          :error-messages="formErrors.UploadOrPayrollFile"
          :disabled="disabled"
          label="Payroll File"
          @change="onChange"
        />
      </v-col>
      <v-col
        v-show="item.uploadOrPayrollFile"
        cols="12"
        md="6"
      >
        <base-section-dropdown
          :value.sync="item.uploadOrPayrollFileDesc"
          section="OE - Upload Or Payroll File"
          :error-messages="formErrors.UploadOrPayrollFileDesc"
          :disabled="disabled"
          label="Payroll File Type"
          @change="onChange"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'OpenEnrollmentTab',

    components: {
      GroupSummary: () => import('./GroupSummary'),
    },

    props: {
      editedItem: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      groupSummaryVisible: false,
      groupId: null,
      disableBrokerGroup: false,

      uploadPayrollFileDescList: [
        'Upload File',
        'Payroll File',
        'Spreadsheet',
        'Forms',
        'Integration',
        'N/A',
      ],

      brokerGroupResource: new TroodyApi('brokerGroup/'),
      benefitAdminSiteResource: new TroodyApi('benefitAdminSite/'),
      identAuthUserRoleResource: new TroodyApi('identAuthUserRole/'),
    }),

    watch: {
      editedItem (val) {
        this.initialize()
      },
    },

    created () {
      this.groupId = this.editedItem.groupId
      this.initialize()
    },

    methods: {
      initialize () {
        this.item = Object.assign({}, this.editedItem)
        this.disableBrokerGroup = this.item.id > 0
      },

      transformItem () {
        this.item.brokerGroupYear = this.item.brokerGroupYear ? Number(this.item.brokerGroupYear) : null
        if (!this.item.brokerGroupYear) {
          delete this.item.brokerGroupYear
        }
        return this.item
      },

      toggleGroupSummary () {
        this.groupSummaryVisible = !this.groupSummaryVisible
      },

      getUploadAssigned () {
        return this.identAuthUserRoleResource.getFrom('distinctEmployeeList/')
      },

      onBrokerGroupChange (bindItem, selectedValue) {
        this.brokerGroupResource.get(selectedValue).then(item => {
          this.groupId = item.groupId
          this.onChange()
        })
      },

      onChange () {
        this.transformItem()
        this.$emit('change', this.item)
      },
    },
  }
</script>
